const environment = window.location.host.includes('ego-now.com') ? 'production' : 'staging'

export default {
  environment: environment,
  apiBaseUrl:
    environment === 'production'
      ? 'https://api.ego-now.com/api/v0'
      : 'https://api.procabnow.com/api/v0',
  baseUrl:
    environment === 'production'
      ? 'https://dashboard.ego-now.com'
      : 'https://dashboard.procabnow.com',
  release: 'fafe4e1294e74de3e4084909b12bb413ce9c1b68'
}
